export class Routes {
  public static LANDING_ROUTE = '/';
  public static YOUR_NFTS = '/your-nfts';
  public static RESOLVE_SWAP = '/resolve-swap/:id';
  public static CREATE_SWAP = '/create-swap';
  public static CREATE_SWAP_CONFIRM = '/create-swap-confirm';
  public static OPEN_SWAPS = '/open-swaps';
  public static PUBLIC_RECENT_SWAPS = '/public-recent-swaps';
  public static RECENT_SWAPS = '/recent-swaps';
  public static RECENT_SWAP_DETAILS = '/recent-swaps/:id';
  public static TERMS_OF_USE = '/terms-of-use';
  public static PRIVACY_POLICY = '/privacy-policy';
  public static ABOUT = '/about-us';
  public static FAQ = '/faq';
}

export const publicRoutes = [
  Routes.LANDING_ROUTE,
  Routes.TERMS_OF_USE,
  Routes.PRIVACY_POLICY,
  Routes.ABOUT,
  Routes.FAQ,
  Routes.PUBLIC_RECENT_SWAPS,
];
